import api from "../lib/api";

export interface Colaborador {
  id: number;
  nome: string;
  email: string;
  ativo: boolean;
  criado_em?: string;
}

export interface ColaboradorProjeto {
  id: number;
  nome: string;
  permissao: 'view' | 'edit';
}

export async function listarColaboradores(): Promise<Colaborador[]> {
  const res = await api.get("/colaboradores");
  return res.data;
}

export async function criarColaborador(data: {
  nome: string;
  email: string;
  senha: string;
}): Promise<Colaborador> {
  const res = await api.post("/colaboradores", data);
  return res.data;
}

export async function atualizarColaborador(
  id: number,
  data: Partial<{ nome: string; email: string; ativo: boolean }>
): Promise<Colaborador> {
  const res = await api.put(`/colaboradores/${id}`, data);
  return res.data;
}

export async function redefinirSenha(
  id: number,
  senha: string
): Promise<void> {
  await api.put(`/colaboradores/${id}/senha`, { senha });
}

export async function removerColaborador(id: number): Promise<void> {
  await api.delete(`/colaboradores/${id}`);
}

export async function listarProjetosColaborador(
  id: number
): Promise<ColaboradorProjeto[]> {
  const res = await api.get(`/colaboradores/${id}/projetos`);
  return res.data;
}

export async function vincularProjeto(
  colaboradorId: number,
  projeto_id: number,
  permissao: 'view' | 'edit' = 'view'
): Promise<void> {
  await api.post(`/colaboradores/${colaboradorId}/projetos`, { projeto_id, permissao });
}

export async function atualizarPermissaoProjeto(
  colaboradorId: number,
  projetoId: number,
  permissao: 'view' | 'edit'
): Promise<void> {
  await api.put(`/colaboradores/${colaboradorId}/projetos/${projetoId}`, { permissao });
}

export async function desvincularProjeto(
  colaboradorId: number,
  projetoId: number
): Promise<void> {
  await api.delete(`/colaboradores/${colaboradorId}/projetos/${projetoId}`);
}
